import { observer } from "mobx-react-lite"
import { useProposalsEditDetailsStore } from "./ProposalsEditDetailsStore"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import GapAutocompleteSingle from "features/gap-components/autocomplete/single/GapAutocompleteSingle"
import Box from "@mui/material/Box"

export default observer(function ProposalsEditDetailsSignees() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   return (
      <>
         <Typography variant="subtitle1">Who should sign?</Typography>
         <Typography variant="caption">Specify who needs to sign for this proposal to be accepted.</Typography>

         <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={4.8}>
               <Signees />
               {proposalsEditDetailsStore.signeesHelperText && <Box sx={{ ml: '14px' }}><Typography variant="caption" sx={{ color: 'rgba(0,0,0,0.6)' }}>{proposalsEditDetailsStore.signeesHelperText}</Typography></Box>}
            </Grid>
            <Grid size={1.2}>
               <SigneesAmount />
            </Grid>
         </Grid>
      </>
   );
})

const Signees = observer(function Signees() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   return <>
      {proposalsEditDetailsStore.formHandler.signees.bindInput(ip =>
         <GapAutocompleteSingle
            {...ip}
            label="Signees"
            options={proposalsEditDetailsStore.signeeOptions}
            disableClearable
            readOnly
         />
      )}
   </>
})

const SigneesAmount = observer(function SigneesAmount() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   if (proposalsEditDetailsStore.fields.signees !== 'certain-number-of-signees') {
      return null
   }

   return proposalsEditDetailsStore.formHandler.signeesAmount.bindInput(ip =>
      <GapAutocompleteSingle
         {...ip}
         label="#"
         options={proposalsEditDetailsStore.signeeAmountOptions}
         disableClearable
         displaySelectedIcon={false}
         readOnly
         fullWidth
      />
   )
})
